"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ParticipationDropRatings } from "./ParticipationDropRatings";
import { format } from "date-fns";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { VotingModal, MobileVotingModal } from "@/components/voting";
import VotingModalButton from "@/components/voting/VotingModalButton";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import WaveDropReactions from "../WaveDropReactions";
interface ParticipationDropFooterProps {
  readonly drop: ExtendedDrop;
}
export default function ParticipationDropFooter(t0) {
  const $ = _c(19);
  const {
    drop
  } = t0;
  const {
    canShowVote
  } = useDropInteractionRules(drop);
  const [isVotingModalOpen, setIsVotingModalOpen] = useState(false);
  const isMobileScreen = useIsMobileScreen();
  let t1;
  if ($[0] !== canShowVote || $[1] !== drop || $[2] !== isMobileScreen || $[3] !== isVotingModalOpen) {
    t1 = canShowVote && <div className="tw-@container sm:tw-ml-[3.25rem] tw-mt-4" onClick={_temp}><div className="tw-flex @[700px]:tw-justify-between tw-flex-col @[700px]:tw-flex-row @[700px]:tw-items-center tw-gap-x-4 tw-gap-y-3"><div className="tw-px-4">{!!drop.raters_count && <ParticipationDropRatings drop={drop} rank={drop.rank} />}</div><div className="@[700px]:tw-ml-auto tw-pt-4 tw-px-6 @[700px]:tw-px-4 tw-flex tw-justify-center @[700px]:tw-pt-0 tw-w-full @[700px]:tw-w-auto tw-border-t tw-border-solid tw-border-iron-800 @[700px]:tw-border-none tw-border-x-0 tw-border-b-0"><VotingModalButton drop={drop} onClick={() => setIsVotingModalOpen(true)} /></div></div>{isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} /> : <VotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} />}</div>;
    $[0] = canShowVote;
    $[1] = drop;
    $[2] = isMobileScreen;
    $[3] = isVotingModalOpen;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== canShowVote || $[6] !== drop) {
    t2 = !canShowVote && !!drop.raters_count && <div className="tw-mt-4 tw-px-4 tw-ml-[3.25rem]"><ParticipationDropRatings drop={drop} rank={drop.rank} /></div>;
    $[5] = canShowVote;
    $[6] = drop;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== drop) {
    t3 = <div className="tw-mt-4 tw-px-4 tw-flex tw-w-[calc(100%-3.25rem)] tw-ml-[3.25rem] tw-items-center tw-gap-x-2 tw-gap-y-1 tw-flex-wrap"><WaveDropReactions drop={drop} /></div>;
    $[8] = drop;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== drop.created_at) {
    t4 = format(new Date(drop.created_at), "h:mm a \xB7 MMM d, yyyy");
    $[10] = drop.created_at;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <div className="tw-mt-4 tw-px-4 sm:tw-ml-[3.25rem] tw-pb-3 tw-text-[11px] tw-text-iron-500 tw-border-t tw-border-iron-800/30">{t4}</div>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t5) {
    t6 = <>{t1}{t2}{t3}{t5}</>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}
function _temp(e) {
  return e.stopPropagation();
}